import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { DirectivesUpgradedModule } from '../../directives/directivesUpgraded.module'
import { InputTextDialogComponent } from './input-text-dialog.component'

@NgModule({
    declarations: [InputTextDialogComponent],
    exports: [InputTextDialogComponent],
    imports: [
        CommonModule,
        FormsModule,
        DirectivesUpgradedModule,
    ],
})
export class InputTextDialogModule {}
